<template>
  <div class="sales-contract-print">
    <div style="width: 210mm; margin: 2mm auto">
      <el-button class="printBtn" type="primary" @click="printHandle">打印</el-button>
    </div>
    <table id="print" class="print-table">
      <thead>
        <tr>
          <td>
            <!-- 这里给页眉占位 -->
            <header class="print-header">
              <img class="company-logo" :src="$tenant.stepIcon">
              <div class="company-standad">GK202506</div>
            </header>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div class="print-area">
              <!-- 正式打印的正文 -->
              <div class="printItem">
                <div class="title">产品销售框架合同</div>
                <div class="flex-justify">
                  <div class="flex-left">
                    合同编号：
                    <span class="display-value">{{contract.clientContractNo}}</span>
                    <input v-model="contract.clientContractNo" placeholder="请输入合同编号" class="editable-input">
                  </div>
                  <div class="flex-right">
                    签订地点、时间：
                    <span class="display-value">{{contract.clientContractAbstract}}</span>
                    <input v-model="contract.clientContractAbstract" placeholder="请输入签订地点和时间" class="editable-input">
                  </div>
                </div>
                <div class="font-bold">
                  甲方：
                  <span class="display-value">{{contract.customerName}}</span>
                  <input v-model="contract.customerName" placeholder="请输入甲方名称" class="editable-input" style="width: 250px;">
                </div>
                <div class="font-bold">
                  乙方：
                  <span class="display-value">{{contract.belongToCustomerNo}}</span>
                  <input v-model="contract.belongToCustomerNo" placeholder="请输入乙方名称" class="editable-input" style="width: 250px;">
                </div>

                <section class="contract-info">
                  <div class="agreement-intro">甲乙双方授权代表经友好协商确认根据下列条款订立本合同：</div>
          
                  <div class="font-bold section-title">1. 产品相关信息</div>
                  <div><span class="font-bold">1.1</span> 甲方在本协议有效期内向乙方采购产品，产品名称、价格等以双方最终确认的书面订单为准。</div>
                  <div><span class="font-bold">1.2</span> 以上价格为包含13%增值税的含税价。合同执行期间如遇国家调整增值税税率，则在不含税价保持不变的基础上调整含税价。</div>
          
                  <div class="font-bold section-title">2. 货物交付</div>
                  <div class="sub-section-title"><span class="font-bold">2.1</span> 订单下达</div>
                  <div><span class="font-bold">2.1.1</span> 甲方订购货物，应当按照要求填写书面订单并签章（订单模板详见附件一），以邮件、微信订单等形式发送给乙方，订单经乙方确认后生效。因甲方原因变更或者取消订单的，则需赔偿乙方相应损失。</div>
          
                  <div class="sub-section-title"><span class="font-bold">2.2</span> 运输方式及收货信息</div>
                  <div class="sub-sub-section-title"><span class="font-bold">2.2.1</span> 运输方式：</div>
                  <div class="checkbox-item"><el-checkbox :checked="contract.transportMethod === '汽车运输'" disabled/>汽车运输：乙方负责送货到甲方单位。</div>
                  <div class="checkbox-item"><el-checkbox :checked="contract.transportMethod === '铁路运输'" disabled/>铁路运输：乙方负责将甲方订购的合同产品送至上海站发运。</div>
                  <div class="checkbox-item"><el-checkbox :checked="contract.transportMethod === '甲方自提'" disabled/>甲方自提</div>
                  <div class="checkbox-item">
                    <el-checkbox :checked="contract.transportMethod === '其他'" disabled/>其他 
                    <span class="display-value">{{contract.otherTransportMethod || '以具体订单为准'}}</span>
                    <input v-model="contract.otherTransportMethod" placeholder="请输入" class="editable-input">
                  </div>
          
                  <div class="sub-sub-section-title"><span class="font-bold">2.2.2</span> 除甲方自提外，甲方确认收货信息如下：</div>
                  <div class="checkbox-item">
                    <el-checkbox :checked="!contract.customerAddress" disabled/>
                    收货地：
                    <span class="display-value">{{contract.customerAddress || '_______'}}</span>
                    <input v-model="contract.customerAddress" style="width:330px;" placeholder="请输入收货地址" class="editable-input">
                    联系人：
                    <span class="display-value">{{contract.customerDeliveryContact || '_______'}}</span>
                    <input v-model="contract.customerDeliveryContact" placeholder="请输入联系人" class="editable-input"> 
                    电话：
                    <span class="display-value">{{contract.customerDeliveryPhone || '_______'}}</span>
                    <input v-model="contract.customerDeliveryPhone" placeholder="请输入联系电话" class="editable-input">
                  </div>
                  <div class="checkbox-item"><el-checkbox :checked="!!contract.deliveryAddress" disabled/>按照甲方订单执行</div>
                  <div style="margin-left: 60px;">接货人因故不在现场时，也可以由现场其他人员接收。</div>
          
                  <div class="font-bold section-title">3. 产品标准及质保</div>
                  <div class="sub-section-title">
                    <span class="font-bold">3.1</span> 
                    产品技术标准：
                    <span class="display-value">{{contract.productStandard || '国家标准'}}</span>
                    <input v-model="contract.productStandard" placeholder="请输入产品技术标准" class="editable-input">
                  </div>
                  <div class="sub-section-title">
                    <span class="font-bold">3.2</span> 
                    产品自出厂之日起，乙方免费保修 
                    <span style="border-bottom: 1px solid #000; padding: 0 10px; display: inline-block;">
                      <span class="display-value">{{contract.warrantyPeriod}}</span>
                      <input
                          v-model="contract.warrantyPeriod"
                          placeholder="请输入保修期"
                          class="editable-input"
                          style="width: 60px;">
                    </span> 
                    个月（因甲方或甲方人员原因导致产品故障的除外），终身提供服务。
                  </div>
                  <div class="sub-section-title"><span class="font-bold">3.3</span> 乙方应随机提供全套的使用维护说明书。</div>
                  <div class="sub-section-title"><span class="font-bold">3.4</span> 乙方有义务对甲方购买产品在国内进行技术支持服务，如涉及到国外技术支持服务，产生费用应由甲方承担。</div>
          
                  <div class="font-bold section-title">4. 产品验收与异议</div>
                  <div>
                    按订货型号和数量，甲方应在货到 
                    <span style="border-bottom: 1px solid #000; padding: 0 10px; display: inline-block;">
                      <span class="display-value">{{contract.inspectionPeriod || '7'}}</span>
                      <input
                          v-model="contract.inspectionPeriod"
                          placeholder="请输入验收期"
                          class="editable-input"
                          style="width: 40px;">
                    </span> 
                    天内验收完毕，在约定验收期内甲方无书面质量异议的，视为验收合格。
                  </div>
          
                  <div class="font-bold section-title">5. 货款结算</div>
                  <div class="sub-section-title">
                    <span class="font-bold">5.1</span> 
                    甲方选择第 
                    <span style="border-bottom: 1px solid #000; padding: 0 10px; display: inline-block;">
                      <span class="display-value">{{contract.paymentMethodType || '4'}}</span>
                      <input
                          v-model="contract.paymentMethodType"
                          placeholder="请输入付款方式编号"
                          class="editable-input"
                          style="width: 40px;">
                    </span> 
                    种方式向乙方支付货款
                  </div>
                  <div>（1）分批下单，每次发货前甲方付清当批次订单款项。</div>
                  <div>
                    （2）乙方根据甲方订单发货，自乙方发货之日起【
                    <span class="display-value">{{contract.paymentDays}}</span>
                    <input v-model="contract.paymentDays" placeholder="请输入" class="editable-input">
                    】天内，甲方向乙方付清该订单全部货款，赊销欠款额度不超过【
                    <span class="display-value">{{contract.creditAmount}}</span>
                    <input v-model="contract.creditAmount" placeholder="请输入" class="editable-input">
                    】万元，滚动计算。
                  </div>
                  <div>
                    （3）乙方根据甲方订单发货，发货前甲方支付乙方当批次订单款项【
                    <span class="display-value">{{contract.prepaymentPercent}}</span>
                    <input v-model="contract.prepaymentPercent" placeholder="请输入" class="editable-input">
                    】%作为预付款，货到指定地点后甲方向乙方支付剩余【{{contract.finalPaymentPercent}}】%货款，赊销欠款额度不超过【
                    <span class="display-value">{{contract.creditAmount}}</span>
                    <input v-model="contract.creditAmount" placeholder="请输入" class="editable-input">
                    】万元，滚动计算。
                  </div>
                  <div>（4）其他：货到甲方验收合格且双方对账确认无误后结算货款。</div>
          
                  <div class="font-bold section-title">6. 双方权利义务</div>
                  <div class="sub-section-title"><span class="font-bold">6.1</span> 价格调整：若因国家政策、原材料或市场情况发生变化，乙方有权在提前30天时间下，通知甲方调整产品价格，甲方新订单按调整后的价格结算货款。</div>
                  <div class="sub-section-title"><span class="font-bold">6.2</span> 若在合同执行过程中，甲方要求临时变更产品类别、数量的，需提前30天以书面形式通知乙方并取得乙方确认。因减少订货数量、变更规格型号所造成的损失由甲方承担。</div>
                  <div class="sub-section-title"><span class="font-bold">6.3</span>  除非乙方有重大过失或故意行为，在其它任何情况下，乙方与合同相关的全部责任不应超过合同价。在乙方应甲方要求提供技术服务过程中，由于甲方或任何第三方提供或使用不适当的设备或者操作不当而引起的损坏，甲乙双方应协商解决。在任何情况下，乙方对于一切特殊的，间接的或继发性的损失概不负责。诸如，但不仅限于，因货物的使用或操作引起的任何经济损失，利润损失，收入损失，使用损失，生产损失，业务损失，资本费用或因甲方或第三方的使用或操作引起的运作中断所导致的费用等。</div>
                  <div class="sub-section-title"><span class="font-bold">6.4</span> 在本协议履行及相关业务合作过程中涉及货款、价格、质量等实质性内容或违约金、赔偿金等涉及乙方经济利益、义务负担的，需乙方确认的文件或/和协议，由乙方加盖公章后生效，否则对乙方不具有约束力。乙方任何部门或个人出具的任何处理意见或允诺，对乙方不具有约束力。</div>
                  <div class="sub-section-title"><span class="font-bold">6.5</span> 甲乙双方确认授权以下联系人及联系方式沟通本合同有关事宜，包括发送采购订单、确认收货、发票开具、核对账目等：</div>
                  <div>
                    （1）甲方联系人：
                    <span class="display-value">{{contract.customerContact}}</span>
                    <input v-model="contract.customerContact" placeholder="请输入甲方联系人" class="editable-input">
                    ，联系方式（包括电话、微信）：
                    <span class="display-value">{{contract.customerPhone}}</span>
                    <input v-model="contract.customerPhone" placeholder="请输入联系电话" class="editable-input">
                    ，邮箱：
                    <span class="display-value">{{contract.buyerContactEmail}}</span>
                    <input v-model="contract.buyerContactEmail" placeholder="请输入邮箱" class="editable-input">
                  </div>
                  <div>
                    （2）乙方联系人：
                    <span class="display-value">{{contract.salesPersonName}}</span>
                    <input v-model="contract.salesPersonName" placeholder="请输入乙方联系人" class="editable-input">
                    ，联系方式（包括电话、微信）：
                    <span class="display-value">{{contract.salesPersonPhone}}</span>
                    <input v-model="contract.salesPersonPhone" placeholder="请输入联系电话" class="editable-input">
                    ，邮箱：
                    <span class="display-value">{{contract.sellerContactEmail}}</span>
                    <input v-model="contract.sellerContactEmail" placeholder="请输入邮箱" class="editable-input">
                  </div>
                  <div>若甲方指定人员不在收货现场，甲方其他工作人员的签字也同等有效。</div>
          
                  <div class="font-bold section-title">7. 违约责任</div>
                  <div class="sub-section-title"><span class="font-bold">7.1</span>本合同签订后，任何一方不得随意解除或终止。乙方逾期交货或因产品质量问题造成甲方损失的，乙方应承担相应的赔偿责任；甲方违反本合同的约定，造成乙方损失的，甲方承担相应的违约责任及损害赔偿责任。</div>
          
                  <div class="font-bold section-title">8. 保密</div>
                  <div class="sub-section-title"><span class="font-bold">8.1</span> 本合同成交价格需要保密。</div>
                  <div class="sub-section-title"><span class="font-bold">8.2</span> 双方不得丢失、复制及向任何第三者透露从对方得到的任何技术文件和专有文件（包括所有的修改和改进资料）。</div>
                  <div class="sub-section-title"><span class="font-bold">8.3</span> 如有人需要借用、参阅或复制对方的技术资料，必须经另外一方书面同意。</div>
                  <div class="sub-section-title"><span class="font-bold">8.4</span> 双方应对本合同履行获知的有关对方的技术信息、经营信息等商业秘密保密，不透露给第三方。保密义务在本合同终止或解除之后继续有效。</div>
          
                  <div class="font-bold section-title">9. 不可抗力</div>
                  <div class="sub-section-title">如遇不可抗力因素造成乙方未能按期交货，乙方应及时通知甲方协商解决。</div>
          
                  <div class="font-bold section-title">10. 争议解决</div>
                  <div class="sub-section-title">因本合同发生纠纷时，双方应当友好协商解决；协商不成的，双方同意提交乙方所在地人民法院诉讼处理。</div>
                  <!-- 第三页 -->
                  <div class="font-bold section-title">
                    11. 甲乙双方同意选择第
                    <span class="display-value">{{contract.paymentMethodType || '_______'}}</span>
                    <input v-model="contract.paymentMethodType" placeholder="请输入用印方式编号" class="editable-input">
                    种方式用印
                  </div>
                  <div class="sub-sub-section-title">（1）物理用印</div>
                  <div>本合同自双方加盖物理公章或合同章后生效。</div>
                  <div class="sub-sub-section-title">（2）电子用印</div>
                  <div>甲乙双方协商一致本协议可以以电子文件的方式签署，双方确认签署前已对本合同内容知晓并认可，双方采用电子用印的：签署方式为一方先行以电子签名的形式签章，随后将已签章的PDF格式的合同电子文件发给另一方，另一方电子签章后本合同生效。后签章方应将双方电子签章后的电子文件发送至对方，该电子文件即为本合同的原件。一方使用电子用印一方使用物理用印的，由一方先行电子签章，随后将已签章的PDF格式的合同电子文件发给另一方，另一方打印后物理用印，后签章方应将双方签章后的纸质合同发送至对方，该纸质合同即为本合同的原件。</div>
          
                  <div class="font-bold section-title">12. 其他</div>
                  <div class="sub-section-title">
                    12.1 本合同经双方盖章之日起生效。本合同有效期自生效之日起至 
                    <span class="display-value">{{contract.year}}</span>
                    <input v-model="contract.year" placeholder="请输入" class="editable-input"> 
                    年 
                    <span class="display-value">{{contract.month}}</span>
                    <input v-model="contract.month" placeholder="请输入" class="editable-input">
                    月   
                    <span class="display-value">{{contract.day}}</span>
                    <input v-model="contract.day" placeholder="请输入" class="editable-input">
                    日止。
                  </div>
                  <div class="sub-section-title">12.2 本协议一式贰份，甲乙双方各执壹份，具有同等法律效力。</div>
          
                  <div style="margin-left: 0;">注：本合同中□为选择项，以“<span style="font-size: 20px;">□</span>”涂黑（<span style="font-size: 20px;">■</span>）为甲乙双方约定有效条款。本合同所有空格均应填写，如不适用请填“无”或“不适用”或采用其他适当的方法。</div>
                  <div style="margin-left: 0;">附件一：订单范本</div>
                  <div style="margin-left: 0;">（以下为签署页，无正文）</div>
                  <section class="signatures">
                    <div class="sign-item font-bold">
                      <div class="sign-label">
                        甲方（盖章）：
                        <span class="display-value">{{contract.customerName}}</span>
                        <input v-model="contract.customerName" placeholder="请输入" class="editable-input" style="width: 220px;">
                      </div>
                      <div class="sign-line">授权代表签字：</div>
                      <div class="sign-date">日期：</div>
                    </div>
                    <div class="sign-item font-bold">
                      <div class="sign-label">乙方（盖章）：新时达工控技术（杭州）有限公司</div>
                      <div class="sign-line">授权代表签字：</div>
                      <div class="sign-date">日期：</div>
                    </div>
                  </section>
                </section>

                <!-- 附件信息 -->
                <!-- 采购订单附件（横版，单独一页） -->
                <div class="landscape-page">
                  <div class="landscape-content">
                    <div class="landscape-header">
                      <div class="landscape-attachment-title">附件二：订单范本</div>
                    </div>
                    <table class="purchase-order-table">
                      <thead>
                        <tr>
                          <th colspan="8">采购订单（2025 年版）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colspan="4">采购订单编号：____________________</td>
                          <td colspan="4">框架主合同编号：____________________</td>
                        </tr>
                        <tr>
                          <td colspan="8">供方名称：新时达工控技术（杭州）有限公司</td>
                        </tr>
                        <tr>
                          <td colspan="8">
                            <div class="flex-justify" style="margin: 10px 0;">
                              <div class="flex-1">需方名称：____________________</div>
                              <div class="flex-1">订货日期：____________________</div>
                              <div class="flex-1">交货需求日期：__________________</div>
                            </div>
                            <div class="font-bold">需方收货信息：</div>
                            <div class="flex-justify" style="margin: 10px 0;text-indent: 2em;">收货地址：____________________，收货人：____________________，收货人联系方式：____________________</div>
                            <div style="margin: 10px 0;text-indent: 2em;">（收货人因故不在现场时，可由现场其他人员接收）</div>
                          </td>
                        </tr>
                        <tr class="table-header">
                          <td>序号</td>
                          <td>产品料号</td>
                          <td>订购产品名称及描述</td>
                          <td>单位</td>
                          <td>数量</td>
                          <td>未税单价（元）</td>
                          <td>含税单价（元）</td>
                          <td>合计（元）</td>
                        </tr>
                        <!-- 产品列表 -->
                        <tr v-for="(item, index) in contract.materialList" :key="index">
                          <td>{{index + 1}}</td>
                          <td>{{item.materialNo || 'XXX'}}</td>
                          <td>{{item.specification || 'XXX'}}</td>
                          <td>{{item.unit || '套'}}</td>
                          <td>
                            <span class="display-value">{{item.quantity}}</span>
                            <input v-model="item.quantity" type="number" class="table-input editable-input" @input="calculateItemTotal">
                          </td>
                          <td>
                            <span class="display-value">{{item.unitPrice}}</span>
                            <input v-model="item.unitPrice" type="number" class="table-input editable-input" @input="calculateItemTotal">
                          </td>
                          <td>{{item.unitPrice || 1000}}</td>
                          <td>{{getItemTotal(item)}}</td>
                        </tr>
                        <!-- 空行 -->
                        <tr v-for="i in 5" :key="'empty-' + i">
                          <td>{{i + 1}}</td>
                          <td/>
                          <td/>
                          <td/>
                          <td/>
                          <td/>
                          <td/>
                          <td/>
                        </tr>
                        <!-- 订单总金额 -->
                        <tr>
                          <td colspan="8">订单总金额：【{{materialItemsTotalPrice}}】元（大写：{{materialItemsTotalPriceUpper}}）</td>
                        </tr>
                        <!-- 备注 -->
                        <tr>
                          <td colspan="8">
                            <div>备注：</div>
                            <div>1.供方按供货单交货，需方不得以任何借口拒收或延期收货，因需方拒收或延期收货造成的供方损失由需方承担。</div>
                            <div>2.请需方核对收到的货物是否与下列清单完全相符。</div>
                            <div>3.如需发现货物与清单不符，请及时与供方联系。</div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="8" class="signature-area">
                            <div>需方单位签章：此处应加盖公章或订单章</div>
                            <div>下单日期：____________________</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import toChineseRMB from "@/util/toChineseRMB.js";
  export default {
    name: "SalesContractPrint",
    data() {
      return {
        contract: {
          clientContractNo: "",
          clientContractAbstract: "",
          customerName: "",
          belongToCustomerNo: "",
          transportMethod: "",
          otherTransportMethod: "",
          deliveryAddress: "",
          productStandard: "",
          warrantyPeriod: "",
          inspectionPeriod: "",
          paymentMethodType: "",
          paymentDays: "",
          creditAmount: "",
          prepaymentPercent: "",
          finalPaymentPercent: "",
          year: "",
          month: "",
          day: "",
          contractNo: "",
          materialList: [],
          // 联系人信息
          buyerContactPerson: "",
          buyerContactPhone: "",
          buyerContactEmail: "",
          sellerContactPerson: "",
          sellerContactPhone: "",
          sellerContactEmail: "",
          // 收货信息
          deliveryContact: "",
          deliveryPhone: "",
        },
      };
    },
    computed: {
      // 合同明细总价
      materialItemsTotalPrice() {
        const materialList = (this.contract && Array.isArray(this.contract.materialList)) ? this.contract.materialList : [];
        const total = materialList.reduce((sum, item) => sum + Number(item.unitPrice * item.quantity || 0), 0);
        const valid = Number.isFinite(total) ? total : 0;
        return valid.toLocaleString("zh-CN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      // 合同明细总价大写
      materialItemsTotalPriceUpper() {
        const materialList = (this.contract && Array.isArray(this.contract.materialList)) ? this.contract.materialList : [];
        const total = materialList.reduce((sum, item) => sum + Number(item.unitPrice * item.quantity || 0), 0);
        return toChineseRMB(total);
      },
    },
    mounted() {
      // 如通过 URL 传入 ids，可在此处读取并请求后端数据
      const id = this.$route && this.$route.query && this.$route.query.id;
      if (id) {
        this.fetchData(id);
      }
    },
    methods: {
      fetchData(id) {
        // 示例：根据后端接口调整
        this.$http.get("basic", `clientContracts/${id}`).then((res) => {
          if (res && res.success) {
            Object.assign(this.contract, res.data || {});
          }
        }).catch(() => {});
      },
      // 计算单个物料总价
      getItemTotal(item) {
        const unitPrice = Number(item.unitPrice || 0);
        const quantity = Number(item.quantity || 0);
        const total = unitPrice * quantity;
        return total.toFixed(2);
      },
      // 触发总价重新计算
      calculateItemTotal() {
        this.$forceUpdate();
      },
      printHandle() {
        // document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
        window.print();
        // window.location.reload();
      },
    },
  };
</script>

<style lang="scss" scoped>
.print-table {
  width: 210mm;
  margin: 0 auto;
  border-collapse: collapse;
  border: 1px solid #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 11pt;
  line-height:1.3;
  color: #000;
  background-color: #f0f0f0;
}
.print-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  /* 屏幕展示保持相对布局（非打印时） */
  line-height: 1.8cm;
  padding: 1.5cm 1.5cm 0;
}
.company-logo { width: 80px; }
.company-standad{
  color: #000;
  font-size: 10pt;
  font-weight: 500;
}
.printItem {
  padding: 0 1.5cm 1.5cm;
  table {
    width: 100%; 
    border: 1px solid #000;
    border-collapse: collapse; 
    margin-bottom: 20px;
    text-align: center;
    thead{
      font-weight: bold;
    }
    tr {
      td {
        border-bottom: 1px solid #000;
        border-right: 1px solid #000;
        padding: 5px;
      }
    }
  }

  
  .flex-justify{
    display: flex;
    justify-content: space-between;
  }
  .font-bold{
    font-weight: bold;
  }
  .section-title{      margin-top: 6px;    margin-bottom: 3px;  }  
  /* 二级标题样式 */  .sub-section-title{    margin:  0;    margin-left: 20px;    }  
  /* 三级标题样式 */  .sub-sub-section-title{    margin-top: 0;    margin-bottom: 0;    margin-left: 40px;    font-weight: bold;  }  
  /* 普通段落样式 */  .contract-info > div:not(.flex-justify):not(.font-bold):not(.section-title):not(.sub-section-title):not(.sub-sub-section-title):not(.agreement-intro):not(.signatures) {    margin-left: 20px;  }  
  /* 二级标题下的内容段落 */  .contract-info > div:nth-of-type(n+2):not(.section-title):not(.sub-section-title):not(.sub-sub-section-title) {    margin-left: 40px;  }  
  /* 三级标题下的内容段落 */  .contract-info > div:nth-of-type(n+3):not(.section-title):not(.sub-section-title):not(.sub-sub-section-title) {    margin-left: 60px;  }
  /* 复选框项目样式 */  
  .checkbox-item {   
     margin-left: 60px !important; 
     .el-checkbox{
      margin-right: 5px;
     }
    
  }

  .agreement-intro{
    padding-top: 20px;
  }
  .title { font-size: 18pt; font-weight: bold; text-align: center; margin-bottom: 10px;}
  .contract-info{
    ::v-deep .el-checkbox__label{
      font-size: 10pt;
    }
    ::v-deep .el-checkbox{
      .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color: white;
        border-color: #000;
      }
      .el-checkbox__inner::after{
        border-color: #000;
      }
      .el-checkbox__inner{
        border-color: #000;
      }
    }
  }
  .contract-item{
    margin-bottom: 20px;
    thead {
      /* 确保表头在打印多页时重复 */
      display: table-header-group;
    }
  }
  .agreement-content .section-title { font-weight: bold; }
  .agreement-content .section-body { min-height: 200px; border: 1px solid #eee; padding: 10px; }
  .signatures { display: flex; justify-content: space-between; margin-top: 40px; }
  .sign-item { width: 45%; }
  .sign-label { margin-bottom: 20px; }
  .sign-line { margin-bottom: 10px; }
}

/* 竖版附件样式 */
.landscape-page {
  page-break-before: always;
  margin: 40px auto 0;
  overflow: hidden;
}

.landscape-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.landscape-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 20px;
}

.landscape-attachment-title {
  font-weight: bold;
}

.step-logo {
  font-size: 22pt;
  font-weight: bold;
  color: #000;
}

.document-no {
  font-size: 11pt;
  color: #000;
}

.purchase-order-table {
  border-collapse: collapse;
  font-size: 11pt;
}

.purchase-order-table th {
  border: 1px solid #000;
  padding: 8px;
  text-align: center;
  font-weight: bold;
}

.purchase-order-table td {
  border: 1px solid #000;
  padding: 8px;
  text-align: left;
}

.purchase-order-table .table-header {
  background-color: #f0f0f0;
}

.purchase-order-table .table-header td {
  font-weight: bold;
  text-align: center;
}

.purchase-order-table .signature-area {
  text-align: right;
  vertical-align: top;
  padding: 40px;
  div{
    margin: 10px 0;
  }
}

.landscape-page-break {
  page-break-before: always;
  width: 210mm;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 处理输入框的打印显示 */
  .display-value {
    display: none;
  }
  
  .editable-input {
    border: none;
    background: transparent;
    outline: none;
    box-shadow: none;
    border-bottom: 1px solid #333;
    padding: 2px 4px;
    margin: 0 2px;
    width: auto;
    min-width: 80px;
    &:focus{
      outline:none
    }
  }
  
  .table-input {
    width: 100%;
    box-sizing: border-box;
    text-align: center;
  }

/* 打印专用规则 */
@media print {
  .printBtn,.editable-input {
    display: none;
  }
  .display-value {
    display: initial;
  }
  .signatures{
    page-break-inside: avoid;
  }
  .print-table{
    font-size: 11pt;
    border:none;
    background-color: #fff;
  }
  .title{
    font-size: 18pt;
  }
  .company-standad, .document-no,.purchase-order-table{
    font-size: 11pt;
  }
  .step-logo {
    font-size: 22pt;
  }

  .print-header{
    padding: 0;
  }
  .print-area, .printItem {
    border: none;
    padding: 0 1px;
  }
  
  /* 实现打印页码功能 */
  @page {
    margin: 0.5cm 1.5cm 1.5cm; /* 底部边距要足够大以容纳页脚 */
    counter-increment: page;
    @bottom-center{
      font-size: 10pt;
      color: #000;
      content: "第 " counter(page) " 页 共 " counter(pages) " 页";
    }
  }
  /* 竖版打印专用规则 */
  .landscape-page {
    page-break-before: always;
    page-break-after: always;
  }
  .landscape-content {
    width: 100%;
  }
  .landscape-header,
  .purchase-order-table,
  .landscape-page-break {
    width: 100%;
  }
}
</style>











